import { createService } from "./serviceFactory";

export const mentalHealthService = createService("mental-healths");
